import { reportLeadToMarketo } from "backend/marketo-api.jsw"
import { updateMktoV2 } from "backend/marketo-api-V2.jsw"

export async function updateMktoLead(lead, program = { programName: '' }) {
    const res = await reportLeadToMarketo(lead, program);
    console.log('update lead: ', res);
    return res;
}

export async function updateMarketoV2(lead, program = '', useMunchkin = false) {
    const res = await updateMktoV2(lead, program, useMunchkin);
    return res;
}